import { render, staticRenderFns } from "./TgTable.vue?vue&type=template&id=1ef1a241"
import script from "./TgTable.vue?vue&type=script&lang=js"
export * from "./TgTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports